import { useMemo } from 'react';
import { getSupplyItemsByHtx } from '../../../../store';
import { useAuth } from '../../../../hooks/useAuth';
import { SUPPLY_FILTER_CHIPS } from '../../../../utils/status';
import { SearchFilterBar } from '@/components/base/SearchFilterBar';

interface Filters {
  search: string;
  nhom: string;
  status: string;
}

interface SupplyFiltersProps {
  filters: Filters;
  onChange: (f: Filters) => void;
  resultCount?: number;
}

const NHOM_LIST = [
  'Tất cả',
  'Giống',
  'Phân bón',
  'Thuốc BVTV',
  'Hóa chất',
  'Bao bì',
  'Công cụ',
  'Dịch vụ làm đất',
  'Dịch vụ phun thuốc',
  'Dịch vụ thu hoạch',
  'Dịch vụ vận chuyển',
  'Khác',
];

export function SupplyFilters({ filters, onChange, resultCount }: SupplyFiltersProps) {
  const { user } = useAuth();
  const items = getSupplyItemsByHtx(user?.htxId);

  // Count per status chip
  const statusCounts = useMemo(() => {
    const result: Record<string, number> = {};
    SUPPLY_FILTER_CHIPS.forEach((chip) => {
      result[chip.key] = items.filter((item) => {
        if (chip.stockCheck === 'zero') return item.stock <= 0;
        if (chip.stockCheck === 'low') return item.stock > 0 && (item.ngưỡngCảnhBáo ? item.stock <= item.ngưỡngCảnhBáo : item.status === 'Sắp hết');
        if (chip.statusMatch) return (chip.statusMatch as readonly string[]).includes(item.status);
        return false;
      }).length;
    });
    return result;
  }, [items]);

  return (
    <div className="mb-4">
      <SearchFilterBar value={filters.search} onChange={(value) => onChange({ ...filters, search: value })} placeholder="Tìm mã, tên vật tư, nhà cung cấp..." selected={filters.status} onSelect={(value) => onChange({ ...filters, status: value })} options={[{ value: '', label: 'Tất cả', count: items.length }, ...SUPPLY_FILTER_CHIPS.map((chip) => ({ value: chip.key, label: chip.label, count: statusCounts[chip.key] || 0 }))]}>
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
          <select value={filters.nhom} onChange={(event) => onChange({ ...filters, nhom: event.target.value })} className="h-11 rounded-xl border border-slate-200 px-3 text-sm">{NHOM_LIST.map((item) => <option key={item} value={item}>{item}</option>)}</select>
          <button type="button" onClick={() => onChange({ search: '', nhom: 'Tất cả', status: '' })} className="h-11 rounded-xl border border-slate-200 text-sm font-medium text-slate-600">Đặt lại bộ lọc</button>
        </div>
      </SearchFilterBar>

      {typeof resultCount === 'number' && (
        <div className="mt-2 text-xs text-slate-500">
          Hiển thị <strong className="text-slate-700">{resultCount}</strong> kết quả
        </div>
      )}
    </div>
  );
}
